import React from "react"
import { IntlProvider } from "react-intl"

import messages_en from "../../assets/data/locales/en.json"
import messages_my from "../../assets/data/locales/my.json"
import messages_cn from "../../assets/data/locales/cn.json"


const menu_messages = {
  en: messages_en,
  my: messages_my,
  cn: messages_cn,  
}

const Context = React.createContext()

class IntlProviderWrapper extends React.Component {
  state = {
    locale: "en",
    messages: menu_messages["en"],
    currency: `${process.env.REACT_APP_CURRENCY}`,
    foreignValue: 1,
    myrValue : 1,
    currencySymbol: `${process.env.REACT_APP_CURRENCY}`
  }

  render() {
    const { children } = this.props
    const { locale, messages } = this.state
    return (
      <Context.Provider
        value={{
          state: this.state,
          switchLanguage: language => {
            this.setState({
              locale: language,
              messages: menu_messages[language]
            })
          },
          switchCurrecny: (currency,foreignValue,myrValue, currencySymbol) => {
            this.setState({
              currency,
              foreignValue,
              myrValue,
              currencySymbol
            })
          }
        }}
      >
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages}
          defaultLocale="en"
        >
          {children}
        </IntlProvider>
      </Context.Provider>
    )
  }
}

export { IntlProviderWrapper, Context as IntlContext }
